
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta } from "/app/src/pages/[...slug].vue?macro=true";
import { default as signin8X4AhIYW3BcJNAexLIvb9LOF1kr1QoMzAllbmWfOZP4Meta } from "/app/src/pages/(auth)/signin.vue?macro=true";
import { default as signoutTS1C948mFZjwlracusYJ_45Ly6mEZRizY61Z_45y0KKT2ykMeta } from "/app/src/pages/(auth)/signout.vue?macro=true";
import { default as homeN3ao3KESmZTqL_d6ZO52op4DzNYVUsIYHiSG3dyyomoMeta } from "/app/src/pages/(private)/home.vue?macro=true";
import { default as previewNd_45KrogmcJAChFXQ_45gLEhSAb2IZTFQxJrEE_mzQhRCEMeta } from "/app/src/pages/(public)/preview.vue?macro=true";
import { default as calendar9wshPIBHnmGcWwrQc8rIUjMJ9N1hjn_45xfXF_b6_459y_EMeta } from "/app/src/pages/(private)/calendar.vue?macro=true";
import { default as indexzWUC84hAgbiSKeRUs3XAXBHmTYKTNRt2evevfT_45MlEYMeta } from "/app/src/pages/(private)/team/index.vue?macro=true";
import { default as reset_45password1Z9MZEIXGSv0nIxJvMTd0ckknN3x8unB840ncucWCMUMeta } from "/app/src/pages/(auth)/reset-password.vue?macro=true";
import { default as informationZFBcDXKzO_bOrmcmDD_qJntE2YPKApi67VjI0Fno2icMeta } from "/app/src/pages/(private)/information.vue?macro=true";
import { default as create_JH56HW0VgPS9EGxm9NKOBlVz_UkyRkUcRk3PM38FocMeta } from "/app/src/pages/(private)/team/create.vue?macro=true";
import { default as forgot_45passwordXTufQbVrOeFP_45mbb8IMrHg6q4RJB_kWmi2Nq_4KrHnAMeta } from "/app/src/pages/(auth)/forgot-password.vue?macro=true";
import { default as publicationsGdPWv9ZHf7SaRe6XLKCXukgG49dV4dVvqj_IbyuVp7gMeta } from "/app/src/pages/(private)/publications.vue?macro=true";
import { default as indexkm4gQ0onaeEUY3_MalQ_45TKncXuVi3WxEvT_45Iv1MzHPEMeta } from "/app/src/pages/(private)/finance/index.vue?macro=true";
import { default as notificationscoGNjZ_45XTLDPGq_45MK2THwSYvJS7_C_45PkSur8E7fzzqoMeta } from "/app/src/pages/(private)/notifications.vue?macro=true";
import { default as archivedwRBcd8T__IAQY9FwKWuGbZtrHKBQQjjYlED2FouIaSYMeta } from "/app/src/pages/(private)/team/archived.vue?macro=true";
import { default as logse6mKEHxXYm31q4INWISqlPsN87pI3hjqCYPt7Erq4EEMeta } from "/app/src/pages/(private)/customers/logs.vue?macro=true";
import { default as indexs8lCL5RtD36_458BT_45qlRa_D6m8k3cC0TQ3W4hkPR4X7cMeta } from "/app/src/pages/(private)/customers/index.vue?macro=true";
import { default as indexfIIJy8IEVgOBMErL0vbT2nRq_FV6olBJPT9pump2VXkMeta } from "/app/src/pages/(private)/reminders/index.vue?macro=true";
import { default as create_45Hg3a0nBvXicKW0RGFWbc2ag6dKm_45px0iZhn1S_45YIOcMeta } from "/app/src/pages/(private)/customers/create.vue?macro=true";
import { default as edit5oQCYMtfE_45ZUfgYy78kLRhlMZrixUWeDHBPmyRy7KrEMeta } from "/app/src/pages/(private)/team/[uuid]/edit.vue?macro=true";
import { default as indexVWYRVqbldYYv1wkgzMK7ReNvUkNRXkNz0_Mt3_lRlzkMeta } from "/app/src/pages/(private)/proceedings/index.vue?macro=true";
import { default as archivedbs22pZUk1AXNAA_2gR0HSlCBIn82IfVNixlXWVvRaQYMeta } from "/app/src/pages/(private)/customers/archived.vue?macro=true";
import { default as edit65LB2oCj5QTiY6Edq3Ibl9u0j4U1Xnu1tKjs5DoFakgMeta } from "/app/src/pages/(private)/customers/[uuid]/edit.vue?macro=true";
import { default as updatemq3QmCXnALAk_45pS_45w6F6q_45ZvJp7gmbK8rt4wCpbtKOgMeta } from "/app/src/pages/(private)/profile/[uuid]/update.vue?macro=true";
import { default as index39nBdTa1LWkLWOvuD5RTFV_L3pWrQVZLnTov5XUdD8wMeta } from "/app/src/pages/(private)/customers/[uuid]/index.vue?macro=true";
import { default as create_45receiptanV_45ZuXOEeQRC7bXqt3dy_45DUhCbMtkkJtvX5s5Wa0a4Meta } from "/app/src/pages/(private)/finance/create-receipt.vue?macro=true";
import { default as legatesZ6xubprThCIOOo3kdC4W_45xkkM9JaRpGwu9iky_32MSYMeta } from "/app/src/pages/(private)/customers/[uuid]/legates.vue?macro=true";
import { default as reportsOqA7v7ANoE2f1z9RN23qQuZ2ZS_PqwATYY2_8u04V04Meta } from "/app/src/pages/(private)/customers/[uuid]/reports.vue?macro=true";
import { default as receipts_45canceledgLuyNb_2Kc5AZvn_45_UlXd4IkDB9GQapre91_E8YmhLYMeta } from "/app/src/pages/(private)/finance/receipts-canceled.vue?macro=true";
import { default as indexxckpi0fZbaeC0ET1UM97duoVJmm5y5aOl3344A0DwxsMeta } from "/app/src/pages/(private)/logs-chamada/[uuid]/index.vue?macro=true";
import { default as indexda05D2J3nWVWs51m5d91yTCV0n7m7Y7yiA1jnMmh1QcMeta } from "/app/src/pages/(private)/precatory-proceedings/index.vue?macro=true";
import { default as legate_45editQRY6X_ISa7Mdmch9FMNqA8c5Dmsxy5OQ54qgkyOuXjsMeta } from "/app/src/pages/(private)/customers/[uuid]/legate-edit.vue?macro=true";
import { default as legate_45view_45t4E4sP_45IK_45juPCMpwYSdvghnrYIQqW3_rFcymYUgGoMeta } from "/app/src/pages/(private)/customers/[uuid]/legate-view.vue?macro=true";
import { default as createDg5afaIL7qzUWwplvi_45ilX6LqLvSYfInZ0g1rFaMWF4Meta } from "/app/src/pages/(private)/precatory-proceedings/create.vue?macro=true";
import { default as _91process_pje_id_93FcCYdbMs_45OFPPQG7ctiwXsGMwEwgpzBhCB1ZaFeJ4lUMeta } from "/app/src/pages/(private)/proceedings/[process_pje_id].vue?macro=true";
import { default as bank_45accountKDbzuVsoQXmxLtY_45zxE2zPK_aiPif5A_45KARDw2PF2TsMeta } from "/app/src/pages/(private)/customers/[uuid]/bank-account.vue?macro=true";
import { default as reset_45passwordJKwkzDwEzLkvzObclOP_HA7vmlp9Fo9G5ubVXQZOxQQMeta } from "/app/src/pages/(private)/profile/[uuid]/reset-password.vue?macro=true";
import { default as legate_45createYiNxWwwJKwmyN_45e0hi90uRXQ__454qumY64t5OGCWrk54Meta } from "/app/src/pages/(private)/customers/[uuid]/legate-create.vue?macro=true";
import { default as archivedhuJcQfSzdVz_hMwr_v_3zNkOpMcix9EzjmESKqniULYMeta } from "/app/src/pages/(private)/precatory-proceedings/archived.vue?macro=true";
import { default as legate_45reportsjDkd0fPXWIoiU9S8_450irigsGNKDCRA11kEo99TMB8BwMeta } from "/app/src/pages/(private)/customers/[uuid]/legate-reports.vue?macro=true";
import { default as editMBLKwsun1CmwhWRKvjHKaR6mccg6lyUTsgBJi20C_IQMeta } from "/app/src/pages/(private)/precatory-proceedings/[uuid]/edit.vue?macro=true";
import { default as death_45certificateddwDHWwL6SvOdt46DAb_45fHCXc11ns0_45VMp0NKrS4T1UMeta } from "/app/src/pages/(private)/customers/[uuid]/death-certificate.vue?macro=true";
import { default as indexeguzlEnBZezUNMq3jeJfW0x9GiyHcd39nT6nmjVJRtMMeta } from "/app/src/pages/(private)/precatory-proceedings/[uuid]/index.vue?macro=true";
import { default as legate_45bank_45accounti3_458dr3AdUwDlaAyCxdljCsr8sCecq8Uz_45hx1vdHD68Meta } from "/app/src/pages/(private)/customers/[uuid]/legate-bank-account.vue?macro=true";
import { default as legate_45death_45certificater0lvIthLv1EbDm_gmdNzNdcE26rQnZNFLiPvLwAEJj8Meta } from "/app/src/pages/(private)/customers/[uuid]/legate-death-certificate.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta || {},
    component: () => import("/app/src/pages/[...slug].vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: { ...(signin8X4AhIYW3BcJNAexLIvb9LOF1kr1QoMzAllbmWfOZP4Meta || {}), ...{"groups":["auth"]} },
    component: () => import("/app/src/pages/(auth)/signin.vue")
  },
  {
    name: "signout",
    path: "/signout",
    meta: {"groups":["auth"]},
    component: () => import("/app/src/pages/(auth)/signout.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: { ...(homeN3ao3KESmZTqL_d6ZO52op4DzNYVUsIYHiSG3dyyomoMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/home.vue")
  },
  {
    name: "preview",
    path: "/preview",
    meta: {"groups":["public"]},
    component: () => import("/app/src/pages/(public)/preview.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    meta: { ...(calendar9wshPIBHnmGcWwrQc8rIUjMJ9N1hjn_45xfXF_b6_459y_EMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/calendar.vue")
  },
  {
    name: "team",
    path: "/team",
    meta: { ...(indexzWUC84hAgbiSKeRUs3XAXBHmTYKTNRt2evevfT_45MlEYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/team/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45password1Z9MZEIXGSv0nIxJvMTd0ckknN3x8unB840ncucWCMUMeta || {}), ...{"groups":["auth"]} },
    component: () => import("/app/src/pages/(auth)/reset-password.vue")
  },
  {
    name: "information",
    path: "/information",
    meta: { ...(informationZFBcDXKzO_bOrmcmDD_qJntE2YPKApi67VjI0Fno2icMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/information.vue")
  },
  {
    name: "team-create",
    path: "/team/create",
    meta: { ...(create_JH56HW0VgPS9EGxm9NKOBlVz_UkyRkUcRk3PM38FocMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/team/create.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordXTufQbVrOeFP_45mbb8IMrHg6q4RJB_kWmi2Nq_4KrHnAMeta || {}), ...{"groups":["auth"]} },
    component: () => import("/app/src/pages/(auth)/forgot-password.vue")
  },
  {
    name: "publications",
    path: "/publications",
    meta: { ...(publicationsGdPWv9ZHf7SaRe6XLKCXukgG49dV4dVvqj_IbyuVp7gMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/publications.vue")
  },
  {
    name: "finance",
    path: "/finance",
    meta: { ...(indexkm4gQ0onaeEUY3_MalQ_45TKncXuVi3WxEvT_45Iv1MzHPEMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/finance/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: { ...(notificationscoGNjZ_45XTLDPGq_45MK2THwSYvJS7_C_45PkSur8E7fzzqoMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/notifications.vue")
  },
  {
    name: "team-archived",
    path: "/team/archived",
    meta: { ...(archivedwRBcd8T__IAQY9FwKWuGbZtrHKBQQjjYlED2FouIaSYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/team/archived.vue")
  },
  {
    name: "customers-logs",
    path: "/customers/logs",
    meta: { ...(logse6mKEHxXYm31q4INWISqlPsN87pI3hjqCYPt7Erq4EEMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/logs.vue")
  },
  {
    name: "customers",
    path: "/customers",
    meta: { ...(indexs8lCL5RtD36_458BT_45qlRa_D6m8k3cC0TQ3W4hkPR4X7cMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/index.vue")
  },
  {
    name: "reminders",
    path: "/reminders",
    meta: { ...(indexfIIJy8IEVgOBMErL0vbT2nRq_FV6olBJPT9pump2VXkMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/reminders/index.vue")
  },
  {
    name: "customers-create",
    path: "/customers/create",
    meta: { ...(create_45Hg3a0nBvXicKW0RGFWbc2ag6dKm_45px0iZhn1S_45YIOcMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/create.vue")
  },
  {
    name: "team-uuid-edit",
    path: "/team/:uuid()/edit",
    meta: { ...(edit5oQCYMtfE_45ZUfgYy78kLRhlMZrixUWeDHBPmyRy7KrEMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/team/[uuid]/edit.vue")
  },
  {
    name: "proceedings",
    path: "/proceedings",
    meta: { ...(indexVWYRVqbldYYv1wkgzMK7ReNvUkNRXkNz0_Mt3_lRlzkMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/proceedings/index.vue")
  },
  {
    name: "customers-archived",
    path: "/customers/archived",
    meta: { ...(archivedbs22pZUk1AXNAA_2gR0HSlCBIn82IfVNixlXWVvRaQYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/archived.vue")
  },
  {
    name: "customers-uuid-edit",
    path: "/customers/:uuid()/edit",
    meta: { ...(edit65LB2oCj5QTiY6Edq3Ibl9u0j4U1Xnu1tKjs5DoFakgMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/edit.vue")
  },
  {
    name: "profile-uuid-update",
    path: "/profile/:uuid()/update",
    meta: { ...(updatemq3QmCXnALAk_45pS_45w6F6q_45ZvJp7gmbK8rt4wCpbtKOgMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/profile/[uuid]/update.vue")
  },
  {
    name: "customers-uuid",
    path: "/customers/:uuid()",
    meta: { ...(index39nBdTa1LWkLWOvuD5RTFV_L3pWrQVZLnTov5XUdD8wMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/index.vue")
  },
  {
    name: "finance-create-receipt",
    path: "/finance/create-receipt",
    meta: { ...(create_45receiptanV_45ZuXOEeQRC7bXqt3dy_45DUhCbMtkkJtvX5s5Wa0a4Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/finance/create-receipt.vue")
  },
  {
    name: "customers-uuid-legates",
    path: "/customers/:uuid()/legates",
    meta: { ...(legatesZ6xubprThCIOOo3kdC4W_45xkkM9JaRpGwu9iky_32MSYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legates.vue")
  },
  {
    name: "customers-uuid-reports",
    path: "/customers/:uuid()/reports",
    meta: { ...(reportsOqA7v7ANoE2f1z9RN23qQuZ2ZS_PqwATYY2_8u04V04Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/reports.vue")
  },
  {
    name: "finance-receipts-canceled",
    path: "/finance/receipts-canceled",
    meta: { ...(receipts_45canceledgLuyNb_2Kc5AZvn_45_UlXd4IkDB9GQapre91_E8YmhLYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/finance/receipts-canceled.vue")
  },
  {
    name: "logs-chamada-uuid",
    path: "/logs-chamada/:uuid()",
    meta: { ...(indexxckpi0fZbaeC0ET1UM97duoVJmm5y5aOl3344A0DwxsMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/logs-chamada/[uuid]/index.vue")
  },
  {
    name: "precatory-proceedings",
    path: "/precatory-proceedings",
    meta: { ...(indexda05D2J3nWVWs51m5d91yTCV0n7m7Y7yiA1jnMmh1QcMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/precatory-proceedings/index.vue")
  },
  {
    name: "customers-uuid-legate-edit",
    path: "/customers/:uuid()/legate-edit",
    meta: { ...(legate_45editQRY6X_ISa7Mdmch9FMNqA8c5Dmsxy5OQ54qgkyOuXjsMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-edit.vue")
  },
  {
    name: "customers-uuid-legate-view",
    path: "/customers/:uuid()/legate-view",
    meta: { ...(legate_45view_45t4E4sP_45IK_45juPCMpwYSdvghnrYIQqW3_rFcymYUgGoMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-view.vue")
  },
  {
    name: "precatory-proceedings-create",
    path: "/precatory-proceedings/create",
    meta: { ...(createDg5afaIL7qzUWwplvi_45ilX6LqLvSYfInZ0g1rFaMWF4Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/precatory-proceedings/create.vue")
  },
  {
    name: "proceedings-process_pje_id",
    path: "/proceedings/:process_pje_id()",
    meta: { ...(_91process_pje_id_93FcCYdbMs_45OFPPQG7ctiwXsGMwEwgpzBhCB1ZaFeJ4lUMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/proceedings/[process_pje_id].vue")
  },
  {
    name: "customers-uuid-bank-account",
    path: "/customers/:uuid()/bank-account",
    meta: { ...(bank_45accountKDbzuVsoQXmxLtY_45zxE2zPK_aiPif5A_45KARDw2PF2TsMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/bank-account.vue")
  },
  {
    name: "profile-uuid-reset-password",
    path: "/profile/:uuid()/reset-password",
    meta: { ...(reset_45passwordJKwkzDwEzLkvzObclOP_HA7vmlp9Fo9G5ubVXQZOxQQMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/profile/[uuid]/reset-password.vue")
  },
  {
    name: "customers-uuid-legate-create",
    path: "/customers/:uuid()/legate-create",
    meta: { ...(legate_45createYiNxWwwJKwmyN_45e0hi90uRXQ__454qumY64t5OGCWrk54Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-create.vue")
  },
  {
    name: "precatory-proceedings-archived",
    path: "/precatory-proceedings/archived",
    meta: { ...(archivedhuJcQfSzdVz_hMwr_v_3zNkOpMcix9EzjmESKqniULYMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/precatory-proceedings/archived.vue")
  },
  {
    name: "customers-uuid-legate-reports",
    path: "/customers/:uuid()/legate-reports",
    meta: { ...(legate_45reportsjDkd0fPXWIoiU9S8_450irigsGNKDCRA11kEo99TMB8BwMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-reports.vue")
  },
  {
    name: "precatory-proceedings-uuid-edit",
    path: "/precatory-proceedings/:uuid()/edit",
    meta: { ...(editMBLKwsun1CmwhWRKvjHKaR6mccg6lyUTsgBJi20C_IQMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/precatory-proceedings/[uuid]/edit.vue")
  },
  {
    name: "customers-uuid-death-certificate",
    path: "/customers/:uuid()/death-certificate",
    meta: { ...(death_45certificateddwDHWwL6SvOdt46DAb_45fHCXc11ns0_45VMp0NKrS4T1UMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/death-certificate.vue")
  },
  {
    name: "precatory-proceedings-uuid",
    path: "/precatory-proceedings/:uuid()",
    meta: { ...(indexeguzlEnBZezUNMq3jeJfW0x9GiyHcd39nT6nmjVJRtMMeta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/precatory-proceedings/[uuid]/index.vue")
  },
  {
    name: "customers-uuid-legate-bank-account",
    path: "/customers/:uuid()/legate-bank-account",
    meta: { ...(legate_45bank_45accounti3_458dr3AdUwDlaAyCxdljCsr8sCecq8Uz_45hx1vdHD68Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-bank-account.vue")
  },
  {
    name: "customers-uuid-legate-death-certificate",
    path: "/customers/:uuid()/legate-death-certificate",
    meta: { ...(legate_45death_45certificater0lvIthLv1EbDm_gmdNzNdcE26rQnZNFLiPvLwAEJj8Meta || {}), ...{"groups":["private"]} },
    component: () => import("/app/src/pages/(private)/customers/[uuid]/legate-death-certificate.vue")
  }
]